export default class FileUpload {
    constructor() {
        this.init();
        this.delete();
        this.download();
        this.initAjaxFileUpload();
    }

    initAjaxFileUpload() {
        $('.ajax-file-upload').each(function () {
            let $this = $(this);

            // Initialize the jQuery File Upload widget:
            $this.fileupload({
                url: $this.data('upload-url'),
                maxChunkSize: 1000000,
                sequentialUploads: true,
                autoUpload: true,
                uploadTemplateId: 'template-upload-' + $this.data('ajax-upload-id'),
                downloadTemplateId: 'template-download-' + $this.data('ajax-upload-id'),
                formData: {
                    _token: window._token,
                    operation: $this.data('operation'),
                    model: $this.data('model'),
                    model_id: $this.data('model-id'),
                    collection: $this.data('collection'),
                }
            });

            // Load existing files:
            $this.addClass('fileupload-processing');
            $.ajax({
                url: $this.data('download-url'),
                dataType: 'json',
                context: $this[0],
                data: {
                    operation: $this.data('operation'),
                    model: $this.data('model'),
                    model_id: $this.data('model-id'),
                    collection: $this.data('collection'),
                }
            })
                .always(function () {
                    $(this).removeClass('fileupload-processing');

                    setTimeout(function () {
                        $('tbody.files').sortable({
                            items: 'tr.reorder',
                            delay: 150,
                            axis: 'y',
                            stop: function (event, ui) {
                                let data = new Array();
                                $('tbody.files tr').each(function () {
                                    if($(this).data('id') != undefined) {
                                        data.push($(this).data('id'));
                                    }
                                });
                                $.ajax({
                                    url: $this.data('reorder-url'),
                                    method: 'POST',
                                    headers: {
                                        'X-CSRF-TOKEN': window._token
                                    },
                                    dataType: 'json',
                                    context: $this[0],
                                    data: {
                                        operation: $this.data('operation'),
                                        model: $this.data('model'),
                                        model_id: $this.data('model-id'),
                                        collection: $this.data('collection'),
                                        ordered_ids: data
                                    },
                                    success: function (data) {
                                        SwalToast.fire({
                                            icon: 'success',
                                            title: data.message
                                        });
                                    },
                                    error: function (err) {

                                    }
                                })
                            }
                        });
                    }, 0);
                })
                .done(function (result) {
                    $(this)
                        .fileupload('option', 'done')
                        // eslint-disable-next-line new-cap
                        .call(this, $.Event('done'), { result: result });
                });

            $this.on('fileuploadcompleted', function(e, data) {
                if ($('tbody.files').lenght > 0) {
                    $('tbody.files').sortable('refresh');
                }
            });

            //Delete confirmation
            let destroyConfirmed = false;
            let destroyEvents = [];
            $this.on('fileuploaddestroy', function (e, data) {
                if (!destroyConfirmed) {
                    e.preventDefault();
                    destroyEvents.push(
                        {
                            target: e.originalEvent.target,
                            type: e.originalEvent.type
                        }
                    );
                    Swal.fire({
                        text: _t('Are you sure you want to delete the selected item?'),
                        icon: "warning",
                        buttonsStyling: false,
                        showCancelButton: true,
                        cancelButtonText: _t('Cancel'),
                        confirmButtonText: _t('Delete'),
                        customClass: {
                            confirmButton: 'btn btn-danger',
                            cancelButton: 'btn btn-default',
                        }
                    }).then(function (result) {
                        if (result.value) {
                            destroyConfirmed = true;
                            //$(e.originalEvent.target).trigger(e.originalEvent.type);
                            $(destroyEvents).each(function (i, evt) {
                                $(evt.target).trigger(evt.type);
                            });
                        }

                        destroyEvents = [];
                    });

                } else {
                    setTimeout(function () {
                        destroyConfirmed = false;
                    }, 0);
                }
            })

            $this.on('fileuploaddestroyfailed', function (e, data) {
                $.ajax(data).fail(function (jqXHR, r) {
                    if(jqXHR.responseJSON.error) {
                        Swal.fire({
                            text: jqXHR.responseJSON.error,
                            icon: "warning",
                            showCancelButton: false,
                        });
                    }
                })
            })
        })
    }

    init() {
        $(document).on('change', '.file-upload', function () {
            var files = $(this).prop("files");
            var attachmentsPreviewContainer = $('.' + $(this).data('preview-container'));
            attachmentsPreviewContainer.empty();
            $.map(files, function (val) {
                var previewFileItem = '<li class="list-group-item" data-name="' + val.name + '">' + val.name + '</li>';
                $(attachmentsPreviewContainer).append(previewFileItem);
            });
        });
    }

    delete() {
        $('body').on('click', '.mailbox-attachment-delete-btn', function () {
            let _that = $(this);
            let destroyUrl = $(_that).data('destroy_url');
            let destroy_msg = $(_that).data('destroy_msg');
            Swal.fire({
                text: destroy_msg,
                icon: "warning",
                buttonsStyling: false,
                showCancelButton: true,
                cancelButtonText: _t('Cancel'),
                confirmButtonText: _t('Delete'),
                customClass: {
                    confirmButton: 'btn btn-danger',
                    cancelButton: 'btn btn-default',
                }
            }).then(function(result) {
                if(result.value) {
                    $.ajax({
                        'url': destroyUrl,
                        'method': 'DELETE',
                        headers: {
                            'X-CSRF-TOKEN': token.content
                        },
                        success: function (res) {
                            $(_that).parent('li').remove();
                        },
                        error: function (err) {

                        }
                    });
                }
            });
        })
    }

    download() {
        $('body').on('click', '.download-media-btn', function (evt) {
            evt.preventDefault();

            let downloadUrl = $(this).data('download_url');

            $.fileDownload(downloadUrl, {
                data: {
                    _token: window._token
                },
                httpMethod: 'POST',
            });
        })
    }
}



// WEBPACK FOOTER //
// ./resources/js/admin-panel/classes/global/FileUpload.js